import useWindowSize from "../Hooks/windowSize";

const Header = (props) => {
  const { handleMovingToLandingPage, navbarEducator } = props;
  const [width, height] = useWindowSize();

  return (
    <div
      className="header"
      style={{
        height:
          navbarEducator && width > 1440
            ? "108px"
            : navbarEducator
            ? "99px"
            : "60px",
      }}
    >
      <img
        src="/images/biscriptuallogo-horizontal.png"
        className="header-logo"
        alt="Biscriptual Logo"
        onClick={handleMovingToLandingPage}
      />
    </div>
  );
};

export default Header;
